import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getAllcommunity, deleteUser } from "../server/rolesAllApi";
import axios from "axios";
// for deletion
import { Modal } from "react-bootstrap";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const HighlightListLayer = () => {
  const [community, setCommunity] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [token, setToken] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();
  const [serialNumbers, setSerialNumbers] = useState([]);
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");
  // for deletion
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);
  }, [community]);

  useEffect(() => {
    if (token) {
      fetchCommunity();
    }
  }, [token, currentPage, itemsPerPage, searchTerm]);

  const fetchCommunity = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-highlights?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      // console.log("Response received:", response);
      const startSerial = (currentPage - 1) * itemsPerPage + 1; // Start serial for the current page
      const usersWithSerial = response.data.data.map((item, index) => ({
        ...item,
        serial: startSerial + index, // Calculate serial number correctly
        statusToggle: !item.status,
      }));
      setCommunity(usersWithSerial);
      setSerialNumbers(usersWithSerial.map((t) => t.serial));
      setTotalItems(response.data.pagination.totalItems); // Set totalItems for pagination
      setTotalPages(response.data.pagination.totalPages);
    } catch (error) {
      console.error("Failed to fetch community:", error);
      setError("Failed to fetch community.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(event.target.value);
    setCurrentPage(1);
  };

  const handleEditHighlight = (item) => {
    navigate("/edit-highlight", { state: { item } });
    // console.log("trader info: ", item);
  };

  // for Deletion
  const handleDeleteClick = (item) => {
    setItemToDelete(item);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const handleConfirmDelete = async () => {
    try {
      // Your delete logic here
      await handleDeleteHighlight(itemToDelete);
      handleCloseDeleteModal();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  const handleDeleteHighlight = async (item) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/delete-highlight/${item._id}`,
        {}, // Empty object for the request body
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setSnackbarMessage("Deleted successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        handleCloseDeleteModal();

        fetchCommunity(); // Call fetchUser() if the deletion is successful
      }
    } catch (error) {
      console.error("Error deleting guest:", error);
      setSnackbarMessage("Failed to delete. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const handleToggleStatus = async (item) => {
    try {
      const updatedStatus = !item.status; // Toggle the current status
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/highlight-status-update/${item._id}`,
        { status: updatedStatus },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        // Update the status locally
        setCommunity((prevtrader) =>
          prevtrader.map((b) =>
            b._id === item._id ? { ...b, status: updatedStatus } : b
          )
        );
        setSnackbarMessage("Status updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Failed to toggle community status:", error);
      setSnackbarMessage("Failed to update status. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  // snackbar
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <div className="card h-100 p-0 radius-12">
      
{loading && (
        <div className="loader-container" style={styles.loaderContainer}>
          <CircularProgress />
        </div>
      )}
      <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
        <div className="d-flex align-items-center flex-wrap gap-3">
          <form
            className="search px-10"
            style={{
              border: "1px solid #6b7280",
              display: "flex",
              alignItems: "center",
              borderRadius: "10px",
            }}
            onSubmit={(e) => e.preventDefault()}
          >
            <Icon
              icon="ion:search-outline"
              className="icon"
              style={{ marginRight: "10px" }}
            />
            <input
              type="text"
              className="bg-base h-40-px"
              name="search"
              onChange={(e) => {
                let value = e.target.value;

                // Remove leading/trailing spaces & allow only alphanumeric and spaces
                value = value.replace(/[^a-zA-Z0-9\s]/g, "").trimStart();

                setSearchTerm(value);
                setCurrentPage(1); // Reset to the first page
              }}
              value={searchTerm}
              placeholder="Search"
            />
          </form>
          {/* <select
            className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
            defaultValue="Select Status"
          >
            <option value="Select Status" disabled>
              Select Status
            </option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select> */}
        </div>
        <Link
          to="/add-highlight"
          className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
        >
          <Icon
            icon="ic:baseline-plus"
            className="icon text-xl line-height-1"
          />
          Add New
        </Link>
      </div>
      <div className="card-body p-24">
        <div className="table-responsive scroll-sm">
          <table className="table bordered-table sm-table mb-0">
            <thead>
              <tr>
                <th scope="col">
                  <div className="d-flex align-items-center gap-10">
                    {/* <div className="form-check style-check d-flex align-items-center">
                      <input
                        className="form-check-input radius-4 border input-form-dark"
                        type="checkbox"
                        name="checkbox"
                        id="selectAll"
                      />
                    </div> */}
                    S.L
                  </div>
                </th>
                <th scope="col">Title</th>
                <th scope="col">Highlight Image</th>
                
                <th scope="col">Created At</th> 
                <th scope="col" className="text-center">
                  Status
                </th>
                {/* <th scope="col" className="text-center">
                  Assign
                </th> */}
                <th scope="col" className="text-center">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {community.length > 0 ? (
                community.map((item, index) => (
                  <tr>
                    <td>
                      <div className="d-flex align-items-center gap-10">
                        {item.serial}
                      </div>
                    </td>
                    <td style={{ width: "399px", wordWrap: "break-word", whiteSpace: "normal" }}>
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <span className="text-md mb-0 fw-normal text-secondary-light">
                            {item.title}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        <img
                          src={
                            item?.icon ||
                            "assets/images/user-grid/user-grid-img14.png"
                          }
                          alt=""
                          className="border br-white border-width-2-px w-100-px h-100-px rounded-circle object-fit-cover"
                        />
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <span className="text-md mb-0 fw-normal text-secondary-light">
                          {new Date(
                          item.createdAt
                        ).toLocaleDateString()}{" "}
                        {new Date(
                          item.createdAt
                        ).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className="text-center">
                      <button
                        onClick={() => handleToggleStatus(item)}
                        className={`bg-${
                          item.status ? "success" : "danger"
                        }-focus text-${
                          item.status ? "success" : "danger"
                        }-600 border border-${
                          item.status ? "success" : "danger"
                        }-main px-24 py-4 radius-4 fw-medium text-sm`}
                        style={{ cursor: "pointer" }}
                      >
                        {item.status ? "Active" : "Inactive"}
                      </button>
                    </td>

                    <td className="text-center">
                      <div className="d-flex align-items-center gap-10 justify-content-center">
                        {/* <button
                          type="button"
                          className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                        >
                          <Icon
                            icon="majesticons:eye-line"
                            className="icon text-xl"
                          />
                        </button> */}
                        <button
                          type="button"
                          className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          onClick={() => handleEditHighlight(item)}
                        >
                          <Icon icon="lucide:edit" className="menu-icon" />
                        </button>
                        {/* for deletion */}
                        <button
                          type="button"
                          className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          onClick={() => handleDeleteClick(item)}
                        >
                          <Icon
                            icon="fluent:delete-24-regular"
                            className="menu-icon"
                          />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    No highlights found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
          <span>
          Showing{" "}
    {community.length === 0 
      ? "0" 
      : `${(currentPage - 1) * itemsPerPage + 1}`}{" "} to{" "}
            {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}{" "}
            entries
          </span>

          <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
            {/* Previous Button */}
            <li className="page-item">
              <Link
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                to="#"
                onClick={() => handlePageChange(currentPage - 1)}
                style={{
                  pointerEvents: currentPage === 1 ? "none" : "auto",
                  opacity: currentPage === 1 ? 0.5 : 1,
                }}
              >
                <Icon icon="ep:d-arrow-left" />
              </Link>
            </li>

            {/* Current Page Number */}
            <li className="page-item">
              <span className="page-link bg-primary-600 text-white fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md">
                {currentPage}
              </span>
            </li>

            {/* Next Button */}
            <li className="page-item">
              <Link
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                to="#"
                onClick={() => handlePageChange(currentPage + 1)}
                style={{
                  pointerEvents: currentPage === totalPages ? "none" : "auto",
                  opacity: currentPage === totalPages ? 0.5 : 1,
                }}
              >
                <Icon icon="ep:d-arrow-right" />
              </Link>
            </li>
          </ul>
        </div>
        {/* for deletion */}
        <Modal
          show={showDeleteModal}
          onHide={handleCloseDeleteModal}
          centered
          backdrop="static"
          size="sm"
        >
          <div className="modal-content radius-16 bg-base">
            <div className="modal-body p-24 text-center">
              <span className="mb-16 fs-1 line-height-1 text-danger d-block">
                <Icon icon="fluent:delete-24-regular" className="menu-icon" />
              </span>
              <h6 className="text-lg fw-semibold text-primary-light mb-0">
                Are you sure you want to delete this highlight?
              </h6>
              <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                <button
                  type="button"
                  onClick={handleCloseDeleteModal}
                  className="w-50 border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleConfirmDelete}
                  className="w-50 btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </Modal>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default HighlightListLayer;
